import React, { Component } from 'react';
import { ModalWrapper } from '@components-library/Modals/ModalWrapper';
import { IFormField } from '@components-shared/forms/formField.interface';
import { getRequestString } from '@components-shared/table/utils/getRequestString';
import { keyMap } from '@locales/lokalise/keyMap';
import { fetchApi } from 'api/fetchApi';
// @ts-ignore
import generator, { getInitialState, mergeState } from 'components/shared/forms/formGenerator';
import FormGenerator from 'components/shared/forms/formGenerator';
import { handleError } from 'utils/errors';
import { TableActionModalProps, TableActionModalState } from '../types';

const FIELDS: IFormField[] = [];
const Form = generator(FIELDS);

class ActionModal extends Component<TableActionModalProps, TableActionModalState> {
  state: TableActionModalState;

  constructor(props: TableActionModalProps) {
    super(props);

    const { fields = [], data, dataSection, noData } = this.props;
    const formData = dataSection ? data[dataSection] : data;

    this.state = {
      form: noData ? { ...getInitialState(fields) } : { ...mergeState(fields, formData) },
    };
  }

  form = React.createRef<ReturnType<typeof FormGenerator>>();

  componentDidMount(): void {
    const { fields } = this.props;

    if (this.form.current) {
      this.form.current.update(fields);
    }
  }

  onChange = (name: any, value: any) => {
    const { form } = this.state;

    form[name] = value;
    this.setState({ form });
  };

  onSubmit = async () => {
    const { form } = this.state;
    const { closeModal, updateData, api, data } = this.props;

    const requestString = getRequestString(api, data);

    try {
      await fetchApi.post(requestString, form);
      updateData(false);
      closeModal();
    } catch (error) {
      handleError('Failed to send data', error);
    }
  };

  render() {
    const { closeModal, modalTitle, name } = this.props;
    const { form } = this.state;

    const actions = [
      {
        title: keyMap.sharedActionsSubmit,
        onClick: this.onSubmit,
      },
      {
        title: keyMap.sharedActionsCancel,
        onClick: closeModal,
        className: 'primary--button',
        noValidate: true,
      },
    ];

    return (
      <ModalWrapper title={modalTitle || name || ''} closeHandler={closeModal}>
        <Form
          className="admin--form column--form"
          form={form}
          onChange={this.onChange}
          actions={actions}
          ref={this.form}
        />
      </ModalWrapper>
    );
  }
}

export default ActionModal;
